module.exports = __webpack_public_path__ + "img/freespin3_multiplier40.5e6fcea5.png";